import { Autocomplete, Box, InputBase, createStyles } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { customStyle, theme } from './CustomAutocompleteStyle';
import * as React from 'react';

import { ThemeProvider } from '@mui/material/styles';

const useStyles = makeStyles(() => createStyles(customStyle));
export const CustomAutocompleteListAndFreeSolo = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ThemeProvider theme={theme}>
      <Autocomplete
        freeSolo

        forcePopupIcon={props.showDropdownIcon ?? true}
        options={props.list}
        value={props.value || null}
        isOptionEqualToValue={(option, value) =>
          option === value || option?.type === value
        }
        noOptionsText={t("Pas d'options")}
        getOptionLabel={(option) => {
          // option can be string (free text) or object (from list)
          if (typeof option === 'string') return option;
          return props.getOptionLabel(option);
        }}
        onInputChange={(event, value) => {
          if (props.onInputChange) props.onInputChange(value);
        }}
        onChange={(event, value) => {
          // value can be string (free text) or object
          if (typeof value === 'string') {
            props.setValue(value);
          } else {
            props.setValue(value);
          }
        }}
        fullWidth
        classes={{
          option: classes.option,
          clearIndicatorDirty: classes.clearIndicator,
          popupIndicator: classes.popupIndicator,
        }}
        className={`${
          props.disabled ? classes.textFieldDisabled : classes.textField
        }`}
        renderOption={(_props, option, state) => {
          const label =
            typeof option === 'string' ? option : props.getOptionLabel(option);

          const isAvailable = option?.isAvailable ?? true;
          const optionStyle = {
            color: isAvailable ? 'inherit' : 'gray',
          };

          if (state.selected)
            return (
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  ...optionStyle,
                }}
                {..._props}
              >
                <Box>{label}</Box>
                <Box>
                  <img
                    style={{ float: 'right' }}
                    src="Images/icon-check.png"
                    alt="icon-check"
                  />
                </Box>
              </Box>
            );
          else
            return (
              <span {..._props} style={optionStyle}>
                {label}
              </span>
            );
        }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;
          return (
            <InputBase
              classes={{ root: classes.root }}
              variant="outlined"
              {...params.InputProps}
              {...rest}
              placeholder={props.placeholder}
            />
          );
        }}
      />
    </ThemeProvider>
  );
};
